var render, staticRenderFns
import script from "./SettingTabs.vue?vue&type=script&lang=ts&"
export * from "./SettingTabs.vue?vue&type=script&lang=ts&"
import style0 from "./SettingTabs.vue?vue&type=style&index=0&id=97380e80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97380e80",
  null
  
)

export default component.exports